module.exports = __webpack_public_path__ + "020cb0746e7e31470f8e2919052a1a07.pdf";